import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.4911 5.04444L9.48264 9.05296C9.92808 10.721 9.49648 12.5746 8.18783 13.8833L1.11682 6.81221C2.42541 5.50356 4.279 5.07197 5.94709 5.51744L9.95561 1.50892",
      fill: "white"
    }, null, -1),
    _createElementVNode("line", {
      x1: "7.32925",
      y1: "8.37629",
      x2: "0.929252",
      y2: "13.9763",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.40002 0.800003L14.2 5.60001",
      stroke: "white"
    }, null, -1)
  ]))]))
}